<div class="survey__screen">

  <header class="survey__top">
    <button type="button" class="survey__iconbtn" data-action="back" aria-label="<%= _lcs( 'Zurück' ) %>" <%= canBack ? '' : 'hidden' %>>
      <i class="icon icon--arrow-left"></i>
    </button>
    <span class="survey__house"><%= house %></span>
    <button type="button" class="survey__iconbtn" data-action="close" aria-label="<%= _lcs( 'Schließen' ) %>">
      <i class="icon icon--x"></i>
    </button>
  </header>

  <!-- Progress as a hiking trail: one waypoint per question, the summit at the end. -->
  <div class="survey-trail" role="progressbar" aria-valuemin="0" aria-valuemax="<%= total %>" aria-valuenow="<%= index %>"
       aria-label="<%= _lcs( 'Fortschritt' ) %>">
    <ol class="survey-trail__path">
      <% for ( let i = 0; i < total; i++ ) { %>
      <li class="survey-trail__point<%= i < index ? ' is-done' : '' %><%= i === index ? ' is-current' : '' %>">
        <% if ( i === index ) { %><span class="survey-trail__hiker" aria-hidden="true">🥾</span><% } %>
      </li>
      <% } %>
      <li class="survey-trail__summit" aria-hidden="true">🏔️</li>
    </ol>
    <p class="survey-trail__meta"><%= remainingLabel %> · <%= durationLabel %></p>
  </div>

  <main class="survey-q survey-q--<%= q.type %>" data-question="<%= q.id %>">
    <h1 class="survey-q__prompt" data-id="prompt" tabindex="-1"><%= q.prompt %></h1>

    <% if ( q.type === 'stars' ) { %>
    <div class="survey-stars" role="group" aria-label="<%= q.prompt %>">
      <% for ( let v = 1; v <= 5; v++ ) { %>
      <button type="button" class="survey-stars__btn<%= answer >= v ? ' is-on' : '' %>" data-action="answer" data-value="<%= v %>"
              aria-pressed="<%= answer === v ? 'true' : 'false' %>" aria-label="<%= _lcs( '{value} von 5', { value: v } ) %>">
        <i class="icon icon--star"></i>
      </button>
      <% } %>
    </div>

    <% } else if ( q.type === 'smiley' ) { %>
    <div class="survey-smileys" role="group" aria-label="<%= q.prompt %>">
      <% smileys.forEach( function( s ) { %>
      <button type="button" class="survey-smileys__btn<%= answer === s.value ? ' is-picked' : '' %>" data-action="answer" data-value="<%= s.value %>"
              aria-pressed="<%= answer === s.value ? 'true' : 'false' %>" aria-label="<%= s.label %>">
        <span class="survey-smileys__face" aria-hidden="true"><%= s.emoji %></span>
      </button>
      <% } ); %>
    </div>

    <% } else if ( q.type === 'nps' ) { %>
    <div class="survey-nps" role="group" aria-label="<%= q.prompt %>">
      <div class="survey-nps__grid">
        <% nps.forEach( function( n ) { %>
        <button type="button" class="survey-nps__btn survey-nps__btn--<%= n.tone %><%= answer === n.value ? ' is-picked' : '' %>"
                data-action="answer" data-value="<%= n.value %>" aria-pressed="<%= answer === n.value ? 'true' : 'false' %>"><%= n.value %></button>
        <% } ); %>
      </div>
      <div class="survey-nps__ends">
        <span><%= _lcs( 'unwahrscheinlich' ) %></span>
        <span><%= _lcs( 'sehr wahrscheinlich' ) %></span>
      </div>
    </div>

    <% } else if ( q.type === 'thumbs' ) { %>
    <div class="survey-thumbs" role="group" aria-label="<%= q.prompt %>">
      <button type="button" class="survey-thumbs__btn survey-thumbs__btn--down<%= answer === 0 ? ' is-picked' : '' %>" data-action="answer" data-value="0"
              aria-pressed="<%= answer === 0 ? 'true' : 'false' %>" aria-label="<%= _lcs( 'Nein' ) %>">
        <i class="icon icon--thumbs-down"></i>
      </button>
      <button type="button" class="survey-thumbs__btn survey-thumbs__btn--up<%= answer === 1 ? ' is-picked' : '' %>" data-action="answer" data-value="1"
              aria-pressed="<%= answer === 1 ? 'true' : 'false' %>" aria-label="<%= _lcs( 'Ja' ) %>">
        <i class="icon icon--thumbs-up"></i>
      </button>
    </div>

    <% } else if ( q.type === 'choice' ) { %>
    <div class="survey-tiles" role="group" aria-label="<%= q.prompt %>">
      <% q.options.forEach( function( o ) { %>
      <button type="button" class="survey-tiles__btn<%= answer === o.key ? ' is-picked' : '' %>" data-action="answer" data-value="<%= o.key %>"
              aria-pressed="<%= answer === o.key ? 'true' : 'false' %>">
        <% if ( o.emoji ) { %><span class="survey-tiles__emoji" aria-hidden="true"><%= o.emoji %></span><% } %>
        <span class="survey-tiles__label"><%= o.label %></span>
      </button>
      <% } ); %>
    </div>

    <% } else if ( q.type === 'chips' ) { %>
    <p class="survey-q__hint"><%= _lcs( 'Mehrfachauswahl möglich' ) %></p>
    <div class="survey-chips" role="group" aria-label="<%= q.prompt %>">
      <% q.options.forEach( function( o ) { %>
      <button type="button" class="survey-chips__chip<%= chips.indexOf( o.key ) >= 0 ? ' is-on' : '' %>" data-action="chip" data-key="<%= o.key %>"
              aria-pressed="<%= chips.indexOf( o.key ) >= 0 ? 'true' : 'false' %>">
        <% if ( o.emoji ) { %><span aria-hidden="true"><%= o.emoji %></span><% } %> <%= o.label %>
      </button>
      <% } ); %>
    </div>
    <button type="button" class="survey__cta" data-action="chips-next"><%= chips.length > 0 ? _lcs( 'Weiter' ) : _lcs( 'Überspringen' ) %></button>

    <% } else if ( q.type === 'comment' ) { %>
    <div class="survey-comment__ask" data-id="comment-ask" <%= commentOpen ? 'hidden' : '' %>>
      <button type="button" class="survey__cta" data-action="comment-open"><%= _lcs( 'Ja, etwas schreiben' ) %></button>
      <button type="button" class="survey__cta survey__cta--ghost" data-action="skip"><%= isLast ? _lcs( 'Nein, fertig' ) : _lcs( 'Nein, weiter' ) %></button>
    </div>
    <div class="survey-comment__box" data-id="comment-box" <%= commentOpen ? '' : 'hidden' %>>
      <textarea class="survey-comment__input" data-id="comment" rows="4" maxlength="1000"
                aria-label="<%= q.prompt %>" placeholder="<%= _lcs( 'Dein Kommentar (optional)' ) %>"><%= typeof answer === 'string' ? answer : '' %></textarea>
      <button type="button" class="survey__cta" data-action="comment-send" <%= typeof answer === 'string' && answer ? '' : 'disabled' %>><%= _lcs( 'Absenden' ) %></button>
      <button type="button" class="survey__skip" data-action="skip"><%= _lcs( 'Überspringen' ) %></button>
    </div>
    <% } %>

    <% if ( q.type !== 'chips' && q.type !== 'comment' ) { %>
    <button type="button" class="survey__skip" data-action="skip"><%= _lcs( 'Überspringen' ) %></button>
    <% } %>
  </main>

  <footer class="survey__note">
    <i class="icon icon--shield-check"></i> <%= _lcs( 'Deine Antworten sind für den Gastgeber anonym.' ) %>
  </footer>
</div>
